export enum CaptchaType {
  TEXT = 'text',
  RECAPTCHA_V3 = 'recaptchav3',
}
export enum PayloadType {
  LEGACY = 'legacy',
  CLASSIC = 'classic',
  MODERN = 'modern',
  FUTURISTIC = 'futuristic',
}
export enum PayloadHeaders {
  PARAM1 = 'ksad',
  PARAM2 = 'otyb',
  PARAM3 = 'kbxa',
  PARAM4 = 'qqmm',
}
export enum AuthType {
  JWT = 'jwt',
  COOKIE = 'cookie',
  OATUH2 = 'oauth2',
  PRE_AUTH = 'preAuth',
}
export const EncryptedPayLoadKey = 'aq_z';
export const EncryptedParamKey = 'pq_b';
